<template>
  <div class="abstracts">
    <h3 class="activeR">增值电信营许可证</h3>
    <el-divider></el-divider>
    <div class="img">
      <el-image
        :src="require('../../assets/zzdx1.png')"
        :preview-src-list="[
          require('../../assets/zzdx1.png'),
          require('../../assets/zzdx3.png')
        ]"
      >
      </el-image>
      <el-image
        :src="require('../../assets/zzdx3.png')"
        :preview-src-list="[
          require('../../assets/zzdx1.png'),
          require('../../assets/zzdx3.png')
        ]"
      >
      </el-image>
    </div>
  </div>
</template>
<style scoped lang="less">
.abstracts {
  .img {
    display: flex;
  }
  .el-image {
    width: 480px;
  }
}
</style>
